<template>
  <v-responsive>
    <v-carousel
      hide-delimiter-background
      show-arrows-on-hover
      style="position: relative"
      height="auto"
      :show-arrows="false"
      cycle
      :interval="6000"
    >
      <v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src">
      </v-carousel-item>
    </v-carousel>

    <v-card
      id="card_slide"
      style="width: 50%; margin-left: 25% !important; position: absolute;"
      color="rgba(0,0,0,0.5)"
      class="pa-4 rounded-card"
    >
      <a class="white--text" style="font-size: 1.5rem; font-weight: 900"
        >¡Bienvenida a BarrePro!
      </a>
    </v-card>

  </v-responsive>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          src: require("@/assets/slider1.jpeg"),
        },
        {
          src: require("@/assets/slider2.jpeg"),
        },
        {
          src: require("@/assets/slider3.jpeg"),
        },
      ],
    };
  },
};
</script>
<style scoped>
.rounded-card {
  border-radius: 50px;
}
@media screen and (max-width: 2000px) {
  #card_slide {
    margin-top: -50% !important;
  }

  #card_slide a {
    font-size: 2.5em !important;
  }
}

@media screen and (max-width: 900px) {
  #card_slide {
    margin-top: -50% !important;
  }

  #card_slide a {
    font-size: 2.5em !important;
  }
}

@media screen and (max-width: 800px) {
  #card_slide {
    margin-top: -12% !important;
  }

  #card_slide a {
    font-size: 2em !important;
  }
}

@media screen and (max-width: 700px) {
  #card_slide {
    margin-top: -30% !important;
  }

  #card_slide a {
    font-size: 1.5em !important;
  }
}

@media screen and (max-width: 700px) {
  #card_slide {
    margin-top: -45% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home_page_components/slider_home.vue